import { NgModule } from '@angular/core';
import { MatCheckboxModule, MatRadioModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule, ReusableHeaderBreadcrumbContainerModule, SharedModule } from '@app/shared';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { DialogModule } from 'primeng/dialog';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DoaDashboardDetailsComponent, MyTasksSalesDOADashboardComponent } from './';

const routes: Routes = [
  {
    path: '', component: MyTasksSalesDOADashboardComponent, data: { title: 'Sales DOA Dashboard' }, canActivate: [AuthGuard]
  },
  {
    path: 'detail', component: DoaDashboardDetailsComponent, data: { title: 'DOA Dashboard Detail' }, canActivate: [AuthGuard]
  }
];
@NgModule({
  declarations: [MyTasksSalesDOADashboardComponent, DoaDashboardDetailsComponent],
  imports: [
    RouterModule.forChild(routes),
    ScrollPanelModule, MatCheckboxModule, MatRadioModule, DialogModule,
    LayoutModule, ReusableHeaderBreadcrumbContainerModule,
    SharedModule,
  ]
})
export class MyTasksSalesDOAModule { }
